import styled from "styled-components";

export const ReservationConfirmWrapper = styled.div`
  width: calc(100% - 52px);
  border-radius: 12px;
  padding: 30px 15px 24px;
  background: #ffffff;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1000;
`;

export const ReservationConfirmContent = styled.div`
  width: 100%;
  height: 87px;
  border-radius: 9.14px;
  background-image: url("/image-web/reservation/seed-back.svg");
  background-size: cover;
  padding-left: 16px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 3px;

  > .name {
    font-weight: 600;
    font-size: 13px;
    color: #ffffffbf;
  }

  > .value {
    font-family: esamanru;
    font-weight: 500;
    font-size: 24px;
    color: #ffffff;
  }
`;

export const ReservationConfirmInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  justify-content: center;
  align-items: center;
  margin: 20px 0 41px;
  > .title {
    color: #121212;
    font-weight: 600;
    font-size: 16px;
    line-height: 140%;
  }

  > .info {
    font-weight: 600;
    font-size: 11px;
    line-height: 140%;
    color: #808080;
  }
`;
